import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Box, Card, CardActionArea, CardContent, CardHeader, CardMedia, List, ListItemButton, ListItemText, Tooltip, Typography } from "@mui/material";
import CENTAvatar from "../CENTAvatar";
import rmsActions from "../../../../actions/rmsActions";
import { getUser, getTasks } from "../../../../reducers";
import ErrorBoundary from "../../../Errors/ErrorBoundary";
import { linkBuilder } from "./TaskFunctions";

function MyTasksCard({ appCode }) {
    const dispatch = useDispatch();
    const tasks = useSelector(getTasks);
    const user = useSelector((state) => getUser(state));

    useEffect(() => {
        dispatch(rmsActions.getTasks(appCode));
    }, [dispatch, appCode]);

    const location = useLocation();
    const refererPath = encodeURIComponent(location.pathname);

    return (
        <Card className="card">
            <CardActionArea component={Link} to="/tasks" centerRipple={false}>
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View all tasks" arrow>
                            <CENTAvatar type="task" />
                        </Tooltip>
                    }
                    title={
                        <Typography component="h2" className="card-header-title">
                            Tasks
                        </Typography>
                    }
                    subheader={
                        <Typography component="span" className="card-header-subtitle">
                            {tasks?.length || 0} outstanding tasks
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                {!tasks?.length > 0 && (
                    <CardMedia
                        component="img"
                        height="240"
                        image="https://cdn.premierit.com/images/banners/themes/office/bnr-office-meeting-02.png"
                        alt="tasks"
                    />
                )}

                {Array.isArray(tasks) && (
                    <Box className="card-content">
                        <ErrorBoundary>
                            <List sx={{width: "100%", height: "350px", overflow: "auto" }}>
                                {tasks.sort((a, b) => a.priority >= b.priority ? 1 : -1)
                                    .map(({uuid, title, resource, description}) => (
                                        <ListItemButton
                                            alignItems="flex-start"
                                            key={uuid}
                                            component="div"
                                        >
                                            <Link to={linkBuilder(resource, user.uuid, refererPath)}>
                                                <ListItemText
                                                    disableTypography={true}
                                                    primary={
                                                        <Typography component="h3" className="list-item-primary">
                                                            {title}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <Typography component="span">
                                                            {description}
                                                        </Typography>
                                                    }
                                                />
                                            </Link>
                                        </ListItemButton>
                                    ))
                                }
                            </List>
                        </ErrorBoundary>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}

export default MyTasksCard;
